import { LL97Thresholds, LL97Calculation } from '../types/ll97';

// LL97 emission factors by building type (metric tons CO₂e/sq ft/year)
// Based on NYC Local Law 97 official regulations (1 RCNY §103-14)
export const LL97_EMISSION_FACTORS: Record<string, { factor2024_2029: number; factor2030_2034: number }> = {
    'Adult Education': { factor2024_2029: 0.00758, factor2030_2034: 0.003565528 },
    'Ambulatory Surgical Center': { factor2024_2029: 0.01181, factor2030_2034: 0.008980612 },
    'Automobile Dealership': { factor2024_2029: 0.00675, factor2030_2034: 0.002824097 },
    'Bank Branch': { factor2024_2029: 0.00987, factor2030_2034: 0.004036172 },
    'Bowling Alley': { factor2024_2029: 0.00574, factor2030_2034: 0.003103815 },
    'College/University': { factor2024_2029: 0.00987, factor2030_2034: 0.002099748 },
    'Convenience Store w/o Gas': { factor2024_2029: 0.00675, factor2030_2034: 0.003540032 },
    'Courthouse': { factor2024_2029: 0.00426, factor2030_2034: 0.001480533 },
    'Data Center': { factor2024_2029: 0.02381, factor2030_2034: 0.014791131 },
    'Distribution Center': { factor2024_2029: 0.00574, factor2030_2034: 0.000991600 },
    'Enclosed Mall': { factor2024_2029: 0.01074, factor2030_2034: 0.003983803 },
    'Financial Office': { factor2024_2029: 0.00846, factor2030_2034: 0.003697004 },
    'Fitness Center / Gym': { factor2024_2029: 0.00987, factor2030_2034: 0.003946728 },
    'Food Sales (C-store, deli)': { factor2024_2029: 0.01181, factor2030_2034: 0.005208880 },
    'Food Service (fast-food)': { factor2024_2029: 0.01181, factor2030_2034: 0.007749414 },
    'General Hospital': { factor2024_2029: 0.02381, factor2030_2034: 0.007335204 },
    'Hotel': { factor2024_2029: 0.00987, factor2030_2034: 0.003850668 },
    'K-12 School': { factor2024_2029: 0.00675, factor2030_2034: 0.002230588 },
    'Laboratory': { factor2024_2029: 0.02381, factor2030_2034: 0.026029868 },
    'Library': { factor2024_2029: 0.00675, factor2030_2034: 0.002218412 },
    'Lifestyle Center (open-air mall)': { factor2024_2029: 0.00846, factor2030_2034: 0.004705850 },
    'Mailing Center / Post Office': { factor2024_2029: 0.00426, factor2030_2034: 0.001980440 },
    'Manufacturing / Industrial': { factor2024_2029: 0.00758, factor2030_2034: 0.001417030 },
    'Medical Office': { factor2024_2029: 0.01074, factor2030_2034: 0.002912778 },
    'Movie Theater': { factor2024_2029: 0.01181, factor2030_2034: 0.005395268 },
    'Multifamily Housing': { factor2024_2029: 0.00675, factor2030_2034: 0.003346640 },
    'Museum': { factor2024_2029: 0.01181, factor2030_2034: 0.005395800 },
    'Non-Refrigerated Warehouse': { factor2024_2029: 0.00426, factor2030_2034: 0.000883187 },
    'Office (general)': { factor2024_2029: 0.00758, factor2030_2034: 0.002690852 },
    'Other – Education': { factor2024_2029: 0.00846, factor2030_2034: 0.002934006 },
    'Other – Entertainment / PA': { factor2024_2029: 0.00987, factor2030_2034: 0.002956738 },
    'Other – Lodging / Res.': { factor2024_2029: 0.00758, factor2030_2034: 0.001901982 },
    'Other – Mall': { factor2024_2029: 0.01074, factor2030_2034: 0.001928226 },
    'Other – Public Services': { factor2024_2029: 0.00758, factor2030_2034: 0.003808033 },
    'Other – Recreation': { factor2024_2029: 0.00987, factor2030_2034: 0.004479570 },
    'Other – Restaurant / Bar': { factor2024_2029: 0.02381, factor2030_2034: 0.008505075 },
    'Other – Services': { factor2024_2029: 0.01074, factor2030_2034: 0.001823381 },
    'Other – Specialty Hospital': { factor2024_2029: 0.02381, factor2030_2034: 0.006321819 },
    'Other – Technology / Sci.': { factor2024_2029: 0.02381, factor2030_2034: 0.010446456 },
    'Outpatient Rehab / PT': { factor2024_2029: 0.01181, factor2030_2034: 0.006018323 },
    'Parking': { factor2024_2029: 0.00426, factor2030_2034: 0.000214421 },
    'Performing Arts': { factor2024_2029: 0.00846, factor2030_2034: 0.002472539 },
    'Personal Services': { factor2024_2029: 0.00574, factor2030_2034: 0.004843037 },
    'Pre-School / Daycare': { factor2024_2029: 0.00675, factor2030_2034: 0.002362874 },
    'Refrigerated Warehouse': { factor2024_2029: 0.00987, factor2030_2034: 0.002852131 },
    'Repair Services': { factor2024_2029: 0.00426, factor2030_2034: 0.002210699 },
    'Residence Hall / Dorm': { factor2024_2029: 0.00758, factor2030_2034: 0.002464089 },
    'Residential Care Facility': { factor2024_2029: 0.01138, factor2030_2034: 0.004893124 },
    'Restaurant': { factor2024_2029: 0.01181, factor2030_2034: 0.004038374 },
    'Retail Store': { factor2024_2029: 0.00758, factor2030_2034: 0.002104490 },
    'Self-Storage Facility': { factor2024_2029: 0.00426, factor2030_2034: 0.000611830 },
    'Senior Care Community': { factor2024_2029: 0.01138, factor2030_2034: 0.004410123 },
    'Social / Meeting Hall': { factor2024_2029: 0.00987, factor2030_2034: 0.003833108 },
    'Strip Mall': { factor2024_2029: 0.01181, factor2030_2034: 0.001361842 },
    'Supermarket / Grocery': { factor2024_2029: 0.02381, factor2030_2034: 0.006755190 },
    'Transportation Terminal': { factor2024_2029: 0.00426, factor2030_2034: 0.000571669 },
    'Urgent Care / Outpatient': { factor2024_2029: 0.01181, factor2030_2034: 0.005772375 },
    'Vocational School': { factor2024_2029: 0.00574, factor2030_2034: 0.004613122 },
    'Wholesale Club / Supercenter': { factor2024_2029: 0.01138, factor2030_2034: 0.004264962 },
    'Worship Facility': { factor2024_2029: 0.00574, factor2030_2034: 0.001230602 }
};

// Legacy structure for backwards compatibility
export const LL97_THRESHOLDS: LL97Thresholds[] = [
    {
        buildingType: 'Office (general)',
        currentThreshold: 0.00758,
        threshold2030: 0.002690852,
        penaltyRate: 268 // $268 per metric ton CO2e
    },
    {
        buildingType: 'Multifamily Housing',
        currentThreshold: 0.00675,
        threshold2030: 0.003346640,
        penaltyRate: 268
    },
    {
        buildingType: 'Retail Store',
        currentThreshold: 0.00758,
        threshold2030: 0.002104490,
        penaltyRate: 268
    },
    {
        buildingType: 'Hotel',
        currentThreshold: 0.00987,
        threshold2030: 0.003850668,
        penaltyRate: 268
    },
    {
        buildingType: 'General Hospital',
        currentThreshold: 0.02381,
        threshold2030: 0.007335204,
        penaltyRate: 268
    }
];

export class LL97Service {
    
    static calculateLL97Fine(
        buildingType: string,
        grossFloorArea: number,
        totalGHGEmissions: number,
        year: number = 2025
    ): LL97Calculation {
        
        const emissionFactor = this.getEmissionLimit(buildingType, year);
        const allowedEmissions = emissionFactor * grossFloorArea; // metric tons CO2e allowed
        
        // Calculate excess emissions in metric tons
        const excessEmissions = Math.max(0, totalGHGEmissions - allowedEmissions);
        
        // Calculate annual fine - only if there's actually excess emissions
        const annualFine = excessEmissions > 0 ? excessEmissions * 268 : 0; // $268 per metric ton CO2e
        
        // Calculate projected 2030 fine
        const emissionFactor2030 = this.getEmissionLimit(buildingType, 2030);
        const allowedEmissions2030 = emissionFactor2030 * grossFloorArea;
        const excessEmissions2030 = Math.max(0, totalGHGEmissions - allowedEmissions2030);
        const projected2030Fine = excessEmissions2030 > 0 ? excessEmissions2030 * 268 : 0;
        
        // Calculate cumulative fines over 10 years
        const cumulativeFines10Year = this.calculateCumulativeFines(annualFine, projected2030Fine);
        
        // Calculate emissions intensity for reporting
        const emissionsIntensity = totalGHGEmissions / grossFloorArea;
        
        return {
            buildingGrossFloorArea: grossFloorArea,
            totalGHGEmissions,
            emissionsIntensity,
            applicableThreshold: emissionFactor,
            excessEmissions,
            currentAnnualFine: annualFine,
            projected2030Fine,
            cumulativeFines10Year
        };
    }
    
    static getThresholdForBuildingType(buildingType: string): LL97Thresholds {
        const normalizedType = this.normalizeBuildingType(buildingType);
        return LL97_THRESHOLDS.find(t => t.buildingType === normalizedType) || LL97_THRESHOLDS[0];
    }
    
    static normalizeBuildingType(buildingType: string): string {
        const type = buildingType.toLowerCase().trim();
        
        // Direct matches first
        for (const key of Object.keys(LL97_EMISSION_FACTORS)) {
            if (key.toLowerCase() === type) {
                return key;
            }
        }
        
        // Fuzzy matching for common variations
        if (type.includes('office') || type.includes('commercial')) return 'Office (general)';
        if (type.includes('multifamily') || type.includes('residential') || type.includes('apartment')) return 'Multifamily Housing';
        if (type.includes('retail') || type.includes('store') || type.includes('shopping')) return 'Retail Store';
        if (type.includes('hotel') || type.includes('lodging')) return 'Hotel';
        if (type.includes('hospital') || type.includes('medical center')) return 'General Hospital';
        if (type.includes('school') && type.includes('k-12')) return 'K-12 School';
        if (type.includes('university') || type.includes('college')) return 'College/University';
        if (type.includes('restaurant') || type.includes('food service')) return 'Restaurant';
        if (type.includes('warehouse') && type.includes('refrigerated')) return 'Refrigerated Warehouse';
        if (type.includes('warehouse')) return 'Non-Refrigerated Warehouse';
        if (type.includes('mall') && type.includes('enclosed')) return 'Enclosed Mall';
        if (type.includes('mall') && type.includes('strip')) return 'Strip Mall';
        if (type.includes('data center')) return 'Data Center';
        if (type.includes('gym') || type.includes('fitness')) return 'Fitness Center / Gym';
        if (type.includes('library')) return 'Library';
        if (type.includes('museum')) return 'Museum';
        if (type.includes('theater') || type.includes('cinema')) return 'Movie Theater';
        if (type.includes('parking')) return 'Parking';
        
        // Default fallback
        return 'Office (general)';
    }
    
    static calculateCumulativeFines(currentFine: number, projected2030Fine: number): number {
        // Calculate cumulative fines over 10 years
        // Current fine for 2025-2029 (5 years), then 2030 fine for 2030-2034 (5 years)
        const currentPeriodFines = currentFine * 5;
        const futurePeriodFines = projected2030Fine * 5;
        
        return currentPeriodFines + futurePeriodFines;
    }
    
    static calculatePotentialSavings(
        currentFine: number,
        projected2030Fine: number,
        energyReductionPercent: number,
        ghgReductionPercent: number
    ): number {
        // Calculate savings based on GHG reduction
        const currentSavings = currentFine * (ghgReductionPercent / 100);
        const futureSavings = projected2030Fine * (ghgReductionPercent / 100);
        
        // Calculate 10-year savings
        const currentPeriodSavings = currentSavings * 5;
        const futurePeriodSavings = futureSavings * 5;
        
        return currentPeriodSavings + futurePeriodSavings;
    }
    
    static getEmissionLimit(buildingType: string, year: number = 2025): number {
        const normalizedType = this.normalizeBuildingType(buildingType);
        const factors = LL97_EMISSION_FACTORS[normalizedType];
        
        if (!factors) {
            // Fallback to Office (general) if building type not found
            const officeFactor = LL97_EMISSION_FACTORS['Office (general)'];
            return year >= 2030 ? officeFactor.factor2030_2034 : officeFactor.factor2024_2029;
        }
        
        return year >= 2030 ? factors.factor2030_2034 : factors.factor2024_2029;
    }
    
    static calculateEmissionsGap(
        buildingType: string,
        grossFloorArea: number,
        totalGHGEmissions: number,
        year: number = 2025
    ): { gap: number; gapPercentage: number } {
        const emissionFactor = this.getEmissionLimit(buildingType, year);
        const allowedEmissions = emissionFactor * grossFloorArea; // metric tons CO2e
        const gap = Math.max(0, totalGHGEmissions - allowedEmissions);
        const gapPercentage = allowedEmissions > 0 ? (gap / allowedEmissions) * 100 : 0;
        
        return { gap, gapPercentage };
    }
}